import angular from "angular";
import ascommon from "../../ascommon";
import { LoginModel } from "./login-models";

angular.module('LoginModule').controller('loginController', ['$scope', 'loginUtils', async function($scope, loginUtils){
    $scope.loginLoading = false;
    $scope.samlLoading = false;
    $scope.autoFocus = false;
    $scope.loginLoading = false;

    const urlParams = new URLSearchParams(window.location.search);
    $scope.errors = [...urlParams.getAll('ErrorMessages')];
    $scope.data = {
        returnUrl: loginUtils.getReturnUrl()
    } as LoginModel;

    addEventListener('load', () => {
        loginUtils.setFingerprint($scope, $scope.data);
        $scope.autoFocus = !$scope.autoFocus; // trigger auto-focus
    });

    addEventListener('pagehide', (event) => {
        $scope.leaveLoginPage();
    });

    // clean up page state when navigating away from the login page
    $scope.leaveLoginPage = function () {
        $scope.loginLoading = false;
        $scope.$apply();
    }

    $scope.standardSignIn = async function () {
        if ($scope.loginLoading === true) { return; }

        $scope.loginLoading = true;

        $scope.errors = [];

        let data = $scope.data;
        data.clientTimezoneOffset = new Date().getTimezoneOffset();

        ascommon.post<LoginModel>(
            "/login",
            data,
            (result) => {
                let urlParams = new URLSearchParams();
                urlParams.set("Fingerprint", data.fingerprint);
                urlParams.set("ReturnUrl", data.returnUrl);
                urlParams.set("ClientTimezoneOffset", data.clientTimezoneOffset.toString());

                return window.location.href = "/LoginNotifications?" + urlParams.toString();
            },
            (error) => {
                switch(error.response.status) {
                    case 401: // forced password change
                        let urlParams = new URLSearchParams(
                            error.response.data.ErrorMessages.map(m => ['ErrorMessages', m])
                        );
                        urlParams.set("ReturnUrl", data.returnUrl);
                        urlParams.set("Username", data.username);

                        return window.location.href = "/ChangePassword?" + urlParams.toString();
                }

                $scope.data.password = "";
                $scope.errors = error.response.data.ErrorMessages;
                $scope.loginLoading = false;
                $scope.$apply();

                $scope.autoFocus = !$scope.autoFocus; // trigger auto-focus
            }
        );
    };

    $scope.samlLogin = function () {
        $scope.samlLoading = true;
        loginUtils.setTimezoneOffset($scope.data);
    }
}]);
